import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../../Reports/ReportCategory";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import AuditTrailCriteria from "./AuditTrailCriteria";
import { Layout } from "@singularsystems/neo-canvas-grid";

@NeoReport("AuditTrail", { category: ReportCategory.CombinedReports })
export default class AuditTrailReport extends Report<AuditTrailCriteria> {

    constructor(
        private userInvestmentApiClient = AppService.get(DomainTypes.ApiClients.User),
        private dataCache = AppService.get(DomainTypes.Services.DataCache)
    ) {
        super(AuditTrailCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout md={2}>
                <div>
                    <Neo.FormGroupInline
                        bind={this.criteria.meta.userId}
                        select={{
                            items: this.userInvestmentApiClient.getUserLookups().then(r => r.data)
                        }}
                    />

                    <Neo.FormGroupInline
                        bind={this.criteria.meta.tableId}
                        select={{ 
                            itemSource: this.dataCache.tables, 
                            displayMember: "tableName", 
                            valueMember: "tableId" }}
                    />
                </div>
            </Neo.GridLayout>
        </div>;
    }

    public getDefaultGridLayout(criteria?: AuditTrailCriteria | undefined, propertyKey?: string | undefined): Layout.IGridLayout | undefined {
        return {
            "root": {
                "headerLines": 2,
                "columns": [
                    {
                        "key": "tableName",
                        "visible": true
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}